<!--
 * @Author: W9013327 v-maijiahua@oppo.com
 * @Date: 2022-12-13 11:43:03
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-03-11 11:01:43
 * @FilePath: \sns-user-frontend\src\components\web\tabs.vue
 * @Description: 
-->
<template>
  <div class="tabs" v-show="tabList">
    <van-tabs 
      ref="vanTabsRef"
      v-model:active="activeName" 
      animated
      @click-tab="onClickTab"
      :sticky="sticky"
      :offsetTop="offsetTop"
      :style="customStyle"
      :ellipsis="false"
      :shrink="props.shrink"
      :color="color"
      :titleActiveColor="titleActiveColor"
      :titleInactiveColor="titleInactiveColor"
    >
      <van-tab 
        v-for="(item, index) in tabList" 
        :title="item.config?.notTranslate ? item.name : $t(item.name, {
          total: item.config.total ? `(${item.config.total})` : ''
        })"
        :name="item.name"
        :key="`${item.name}${index}`"
      >
        <!-- 插槽 -->
        <slot v-bind="{item, index}"></slot>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref, watch, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute()
const { proxy } = getCurrentInstance()

const emit = defineEmits(['getCuttrentTab'])

const props = defineProps({
  tabList: {
    type: Array,
  },
  defaultActive: {
    type: String,
    default: ''
  },
  shrink: {
    type: Boolean,
    default: false
  },
  tabsType: {
    type: String,
    default: ''
  },
  sticky: {
    type: Boolean,
    default: false
  },
  offsetTop: {
    type: [String, Number],
    default: ''
  },
  color: {
    type: String,
    default: ''
  },
  titleActiveColor: {
    type: String,
    default: ''
  },
  titleInactiveColor: {
    type: String,
    default: ''
  },
})

let tabList = ref(null)
const customStyle = ref({})

const activeName = ref(props.tabList ? props.tabList[0].name : '')
const vanTabsRef = ref(null)


const onClickTab = ({ name }) => {
  emit('getCuttrentTab', name)
  proxy.$ga(props.tabsType === 'search' ? 'search_nav' : 'click_top_nav', {
    "screen_name": route.name,
    "nav_name": activeName.value
  })
}

// 设置激活tab底线宽度
const setTabLineWidth = (val) => {
  if (!props.tabList) return
  const activeIndex = props.tabList.findIndex(i => i.name === val)
  const width = vanTabsRef.value?.$el.getElementsByClassName('van-tab__text')[activeIndex]?.offsetWidth
  customStyle.value = {
    '--van-tabs-bottom-bar-width': `${width}px`
  }
}

const tabsList = computed(() => {
  return props.tabList.map(i => {
    return {
      name: i.name,
      config: i.config
    }
  })
})
watch(() => props.tabList, (val) => {
  if (val && val.length) {
    tabList.value = [ ...val ]
  }
}, {
  immediate: true,
  deep: true
})

watch(() => props.defaultActive, (val) => {
  activeName.value = val
}, {
  deep: true
})

watch([activeName, tabList], ([nameVal], [tabValue]) => {
  nextTick(() => {
    setTabLineWidth(nameVal)
  })
}, {
  immediate: true,
  deep: true
})

defineExpose({
  setTabLineWidth
})
</script>

<style lang="postcss" scoped>
.tabs {
  :deep(.van-tabs) {
    --van-tab-font-size: 16px;
    --van-tabs-line-height: 48px;
    --van-tabs-bottom-bar-height: 2px;
    --van-tabs-bottom-bar-color: var(--theme);
    .van-tabs__wrap {
      position: relative;
      display: flex;
      justify-content: center;
      width: 100%;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 1px;
        box-shadow: 0 0.33px 0 0 rgb(0 0 0 / 12%);
        width: 1000vw;
      }
      .van-tabs__nav {
        width: 792px;
      }
    }
    .van-tab__panel {
      cursor: default;
    }
  }
}
</style>